module.exports = __webpack_public_path__ + "95b3630a518e1cb64aa6049ca54c52af.svg";